// import state from "./state"

// export const getUserID = (state) => {
//     return (state.userDetails._id)
// }

export const getCurrentForm = (state) => {
    return (state.currentForm);
}